module.exports = __webpack_public_path__ + "static/img/li2_5.c6ed2634.png";